var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoliciesSold0B1908C23F7151Cb9669E0Ce4E991966(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1899",
    "data-name": "Group 1899",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.639,
    height: 54.105,
    viewBox: "0 0 41.639 54.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48301",
    "data-name": "Path 48301",
    d: "M1277.7,674.694h-14.175a3.08,3.08,0,0,1-3.076-3.076V633.565a3.058,3.058,0,0,1,.9-2.175l5.488-5.489a3.057,3.057,0,0,1,2.176-.9h24.914a3.08,3.08,0,0,1,3.076,3.076v21.651a.978.978,0,0,1-1.956,0V628.076a1.122,1.122,0,0,0-1.121-1.121h-24.914a1.114,1.114,0,0,0-.792.328l-5.489,5.489a1.112,1.112,0,0,0-.328.792v38.053a1.122,1.122,0,0,0,1.12,1.121H1277.7a.978.978,0,0,1,0,1.956Z",
    transform: "translate(-1260.452 -625)",
    fill: "#bebebe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48302",
    "data-name": "Path 48302",
    d: "M1427.229,810.867h-5.342a.978.978,0,1,1,0-1.956h5.342a.978.978,0,0,1,0,1.956Z",
    transform: "translate(-1402.927 -788.301)",
    fill: "#bebebe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48303",
    "data-name": "Path 48303",
    d: "M1271.454,633.963h-5.841a.978.978,0,0,1,0-1.956h5.755v-5.7a.978.978,0,1,1,1.956,0v5.79A1.872,1.872,0,0,1,1271.454,633.963Z",
    transform: "translate(-1264.167 -625.289)",
    fill: "#bebebe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48304",
    "data-name": "Path 48304",
    d: "M1335.952,734.411h-23.066a.978.978,0,1,1,0-1.956h23.066a.978.978,0,1,1,0,1.956Z",
    transform: "translate(-1306.141 -720.413)",
    fill: "#bebebe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48305",
    "data-name": "Path 48305",
    d: "M1321.315,810.867h-8.429a.978.978,0,1,1,0-1.956h8.429a.978.978,0,1,1,0,1.956Z",
    transform: "translate(-1306.141 -788.301)",
    fill: "#bebebe"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48306",
    "data-name": "Path 48306",
    d: "M1335.952,772.64h-23.066a.978.978,0,1,1,0-1.956h23.066a.978.978,0,1,1,0,1.956Z",
    transform: "translate(-1306.141 -754.357)",
    fill: "#bebebe"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48307",
    "data-name": "Path 48307",
    d: "M1480.475,948.1h0a.977.977,0,0,1-.692-.287l-3.83-3.829a.978.978,0,0,1,1.383-1.383l3.139,3.138,5.568-5.568a.978.978,0,0,1,1.383,1.383l-6.26,6.26A.976.976,0,0,1,1480.475,948.1Z",
    transform: "translate(-1451.549 -904.593)",
    fill: "#bebebe"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48308",
    "data-name": "Path 48308",
    d: "M1432.737,873.722a.977.977,0,0,1-.538-.161l-1.092-.72c-.554-.366-5.467-3.611-7.155-4.858a8.138,8.138,0,0,1-3.043-6.6V849.747a.978.978,0,0,1,.978-.978c4.537,0,10.195-4.34,10.252-4.384a.977.977,0,0,1,1.2,0h0c.057.044,5.716,4.384,10.252,4.384a.978.978,0,0,1,.978.978v11.632a8.139,8.139,0,0,1-3.043,6.6c-1.69,1.249-6.6,4.493-7.157,4.858l-1.09.719A.975.975,0,0,1,1432.737,873.722Zm-9.874-23.048v10.706a6.188,6.188,0,0,0,2.251,5.032c1.647,1.217,6.519,4.435,7.069,4.8l.554.365.551-.364c.55-.362,5.422-3.579,7.072-4.8a6.188,6.188,0,0,0,2.249-5.032V850.673a13.959,13.959,0,0,1-3.118-.719,23.932,23.932,0,0,1-3.649-1.644,32.307,32.307,0,0,1-3.105-1.94,32.438,32.438,0,0,1-3.105,1.94,23.892,23.892,0,0,1-3.65,1.644A13.951,13.951,0,0,1,1422.864,850.673Zm9.874-5.515h0Z",
    transform: "translate(-1402.927 -819.617)",
    fill: "#bebebe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliciesSold0B1908C23F7151Cb9669E0Ce4E991966);
export default __webpack_public_path__ + "static/media/policies-sold.0b1908c23f7151cb9669e0ce4e991966.0b1908c23f7151cb9669e0ce4e991966.svg";
export { ForwardRef as ReactComponent };